/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum CapitalSubtype {
    INTELLECTUAL = 'Intellectual',
    FINANCIAL = 'Financial',
    CULTURAL = 'Cultural',
    BUILT = 'Built',
    POLITICAL = 'Political',
    INDIVIDUAL = 'Individual',
    SOCIAL = 'Social',
}
